import styles from "@/app/styles/components/common/pagination.module.scss";

const Pagination = ({ items, pageSize, currentPage, onPageChange }) => {

    if(!items) {
        return null
    }

    const pagesCount = Math.ceil(items / pageSize);

    if (pagesCount === 1) {
        return null
    }
   
    let pagesToShow = [];
    let startPage = Math.max(currentPage - 2, 1);
    let endPage = Math.min(startPage + 4, pagesCount);

    if (startPage > 1) {
        pagesToShow.push(1);

        if (startPage > 2) {
            pagesToShow.push('...');
        }
    }
    
    for (let i = startPage; i <= endPage; i++) {
        pagesToShow.push(i);
    }
    
    if (endPage < pagesCount) {
        if (endPage < pagesCount - 1) {
            pagesToShow.push('...');
        }
        pagesToShow.push(pagesCount);
    }
    
    return (
        <div className={styles.paginationMain}>
            <button
                className={`${styles.pageBtn} ${styles.btnPrevious} ${styles.pageLink}`}
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
            >
            </button>
            <ul className={styles.paginationList}>
                {pagesToShow.map((page, index) => (
                    <li key={index}
                        className={`${page === currentPage ? styles.pageItemDisabled : styles.pageItem } ${
                        page === currentPage ? styles.pageItemActive : " "
                    }`} onClick={() => onPageChange(page)} >
                        {page === '...' ? (
                            <span className={styles.ellipsis}>...</span>
                        ) : (
                            <a className={styles.pageLink} >
                                {page}
                            </a>
                        )}
                    </li>
                ))}
            </ul>
            <button
                className={`${styles.pageBtn} ${styles.btnNext} ${styles.pageLink}`}
                disabled={currentPage === pagesCount}
                onClick={() => onPageChange(currentPage + 1)}
            >
            </button>
        </div>
    )
}
export default Pagination



